import { useRef, useState } from 'react';
import { useAppState } from '../context/OmniboxJsonConverterContext';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { saveSetting, loadSettings, loadTechniqueSettings } from './converterHelperFunctions';
import CloseIcon from '@mui/icons-material/Close';


function RenameTemplateModal() {
  const { openRenameTemplate, handleCloseRenameTemplate, detectedTechnique, selectedSetting, setSelectedSetting, selectedColumns, setSelectedColumns } = useAppState();
  
  const templateNameRef = useRef();

  const [nameExists, setNameExists] = useState(false);
  const [nameEmpty, setNameEmpty] = useState(false);

  // const savedTemplates = loadTechniqueSettings(detectedTechnique)['templates'];

  const removeTemplate = (templateName) => {
    const saved = loadSettings();
    delete saved[detectedTechnique]['templates'][templateName];

    localStorage.setItem('omnibox_json_converter', JSON.stringify(saved));
  }

  const handleSaveRenamedTemplate = () => {
    const templateRename = templateNameRef.current.value;
    const savedTemplates = loadTechniqueSettings(detectedTechnique)['templates'];
    
    if (!Object.keys(savedTemplates).includes(templateRename)) {
      if (templateRename !== '') {
        removeTemplate(selectedSetting);
        saveSetting(detectedTechnique, templateRename, selectedColumns);
        setSelectedSetting(templateRename);

        handleCloseRenameTemplate();
      }
      else { 
        setNameEmpty(true);
      }
    }
    else {
      setNameExists(true);
    }
  }

  return (
    <Dialog
      open={openRenameTemplate}
      onClose={handleCloseRenameTemplate}
      PaperProps={{
        sx: {
          p: 1.5,
          width: '20%',
          minWidth: '350px',
        }
      }}
    >
      <DialogTitle
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 0, mb: 0.5}}
      >
        <Typography fontSize='16px' variant='body1'>Rename Template: {selectedSetting}</Typography>
        <IconButton title='Close' onClick={handleCloseRenameTemplate}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0, mb: 1.5 }}>
        <Box component='form' onSubmit={(e) => { e.preventDefault(); handleSaveRenamedTemplate() }}>
          <Stack direction='row' spacing={1} alignItems='center'>
            <Typography variant='body1' color='text.secondary' fontSize='14px' sx={{ minWidth: '25%' }}>New Name:</Typography>
            <TextField inputRef={templateNameRef} variant='outlined' size='small' autoComplete='off' error={nameEmpty} fullWidth autoFocus onChange={() => setNameEmpty(false)} inputProps={{ sx: { fontSize: '14px' } }} />
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 0 }}>
        <Button variant='contained' size='small' onClick={handleSaveRenamedTemplate}>Save</Button>
      </DialogActions>
      <Snackbar
        open={nameExists}
        autoHideDuration={5000}
        onClose={() => setNameExists(false)}
        message='A template with this name already exists.'
      />
      <Snackbar
        open={nameEmpty}
        autoHideDuration={5000}
        onClose={() => setNameEmpty(false)}
        message='Template name cannot be empty.'
      />
    </Dialog>
  )
}

export default RenameTemplateModal;